<template>
  <div class="ksl_page">
    <header class="ksl_header_bar">
      <el-row type="flex" justify="start" align="middle">
        <el-col :xs="8" :sm="6" :md="4" :lg="3" :xl="5">
          <div class="grid-content bg-purple"></div>
        </el-col>
        <el-col :xs="11" :sm="11" :md="11" :lg="11" :xl="11" style="text-align: left;display: flex;align-items: center">
          <img style="width: 46px" src="@/assets/logo.png">
          <div @click="goToDoUrl(3)" style="margin-left: 40px;cursor:pointer">大学好课</div>
          <div @click="goToDoUrl(4)" style="margin-left: 40px;cursor:pointer">考尚拉专升本</div>
        </el-col>
        <el-col :xs="11" :sm="11" :md="11" :lg="11" :xl="11">
          <div style="font-size: 16px;text-align: right">
            考尚拉—满足多元需求的学习好帮手
          </div>

        </el-col>
        <el-col :xs="8" :sm="6" :md="4" :lg="3" :xl="5">
          <div class="grid-content bg-purple"></div>
        </el-col>
      </el-row>
    </header>
    <section class="ksl_section_one">
      <transition name="el-fade-in">
        <img class="ksl_section_one_title_img" src="@/assets/zsb_title.png">
      </transition>

      <div class="ksl_section_one_title_desc">助力专升本学子的全能教育 APP</div>
      <div class="ksl_section_one_download">
        <el-row type="flex">
          <el-col v-if="is_pt=== 'ios' || is_pt === 'all'" :span=" is_pt === 'all' ? 8 : 12" class="is-right"
                  style="align-items: flex-end;align-items: center">
            <div class="ksl_section_one_download_item" @click="downloadApp(1)">
              <img src="@/assets/ios.png">
              App Store
            </div>
          </el-col>
          <el-col :span=" is_pt === 'all' ? 8 : 12" :class="is_pt === 'all' ||  is_pt === 'android' ? 'is-right' : ''"
                  v-if="is_pt === 'android' || is_pt === 'all'">
            <!--            <a :href="android_url">-->
            <div class="ksl_section_one_download_item" @click="downloadApp(2)">
              <img src="@/assets/android.png">
              应用商店下载
            </div>
            <!--            </a>-->
          </el-col>
          <el-col :span=" is_pt === 'all' ? 8 : 12" :class="is_pt === 'all' ? 'is-left' : ''"
                  v-if="is_pt === 'android' || is_pt === 'all'">
            <!--            <a :href="local_url">-->
            <div class="ksl_section_one_download_item" @click="downloadApp(3)">
              <img src="@/assets/local_download.png">
              本地下载
            </div>
            <!--            </a>-->
          </el-col>
        </el-row>
      </div>
      <img class="ksl_section_one_title_phone" src="@/assets/phone.png">
    </section>
    <section class="ksl_section_two">

      <!--      </div>-->

    </section>
    <section class="ksl_section_tree">
    </section>
    <section class="ksl_section_four">
    </section>
    <section class="ksl_section_five">
    </section>
    <footer class="ksl_footer">
      <div class="ksl_footer_content">
        <div class="ksl_footer_left">
          <div class="ksl_footer_left_title">联系我们</div>
          <div class="ksl_footer_left_info">
            <div>湖南考尚拉科技有限公司</div>
            <div style="white-space: nowrap">地址：湖南省长沙市岳麓区咸嘉湖街道润泽园社区枫林二路36号会山家园7栋1409</div>
            <div>联系电话：15116366672</div>
          </div>

        </div>

        <div class="ksl_footer_right" id="map">

        </div>
      </div>
      <div class="ksl_footer_icp">
        <div>网站：<a href="https://beian.miit.gov.cn/">湘ICP备2021021177号</a>&APP：<a href="https://beian.miit.gov.cn/">湘ICP备2021021177号-7A</a>
        </div>
        <div class="ksl_footer_agreement" @click="goToDoUrl(1)">隐私协议</div>
        <div class="ksl_footer_agreement" @click="goToDoUrl(2)">用户协议</div>
      </div>
      <div class="ksl_footer_copyright">
        ©CopyRight 2021-{{currentYear}} kaoshla.com
      </div>
    </footer>

    <el-dialog
      :title="title"
      :visible.sync="dialogVisible"
      width="30%">
      <h3>扫描二维码下载</h3>
      <img width="300px" :src="qr_url" alt="https://mp-oss.kaoshla.com/app/zsb_ios_download_qr.png">
    </el-dialog>
    <div v-show="showTip" id="weixinTip" ref="weixin" class="wxtip">
      <p class="wxtip-txt">
        在微信中无法下载APP
        <br />
        1. 请点击右上角按钮
        <br />
        2. 选择【在浏览器中打开】
      </p>
    </div>
  </div>

</template>

<script>
import {getAppDownloadUrl} from "../../api";

export default {
  data() {
    return {
      map: null,
      point: null,
      is_pt: "all",
      ios_url: "",
      ios_img: "",
      android_url: "",
      local_url: "",
      local_img: "",
      android_img: "",
      isWeiXin:false,
      showTip:false,
      qr_url: "",
      title: "",
      currentYear: new Date().getFullYear(),
      dialogVisible: false
    }
  },
  created() {
    let u = navigator.userAgent;
    let isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1;   //判断是否是 android终端
    let isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);     //判断是否是 iOS终端
    if (isAndroid) {
      this.is_pt = "android"
    } else if (isIOS) {
      this.is_pt = "ios"
    } else {
      this.is_pt = "all"
    }
    this.isWeiXin = navigator.userAgent.toLowerCase().indexOf('micromessenger') > -1 ? true : false
    if (this.isWeiXin){
      this.showTip = true
    }
  },
  methods: {
    downloadApp(type) {
      switch (type) {
        case 1:
          if (this.is_pt === 'ios') {

            if (this.isWeiXin) {
              this.showTip = true
              window.location.hash = 'download' // 改变hash，便于浏览器打开时直接跳转AppStore
              return;
            }
            // 苹果商店链接地址
            window.location.href = this.ios_url;
          }
          if (this.is_pt === 'all') {
            this.qr_url = this.ios_img;
            this.title = "App Store 下载"
            this.dialogVisible = true;
          }
          break;
        case 2:
          if (this.is_pt === 'android') {
            window.location.href = this.android_url;
          }
          if (this.is_pt === 'all') {
            this.qr_url = this.android_img;
            this.title = "应用商店下载"
            this.dialogVisible = true;
          }
          break;
        case 3:
          if (this.is_pt === 'all') {
            this.title = "本地下载"
            this.qr_url = this.local_img;
            this.dialogVisible = true;
          }else {
            if (this.isWeiXin) {
              this.showTip = true
              window.location.hash = 'download' // 改变hash，便于浏览器打开时直接跳转AppStore

              return;
            }
            window.location.href = this.local_url;
          }
          break;
      }
    },
    goToDoUrl(type) {
      switch (type) {
        case 1:
          this.$router.push('/zsb/privacy-agreement');
          break;
        case 2:
          this.$router.push('/zsb/user-agreement');
          break;
        case 3:
          this.$router.push('/');
          break;
        case 4:
          this.$router.push('/zsb');
          break;
      }
    },
    async getAppDownloadInfo() {
      try {
        const data = await getAppDownloadUrl("/config/getAppDownloadUrl"); // 假设获取用户ID为1的用户信息
        this.local_url = data.data.local_url;
        this.local_img = data.data.local_img ? data.data.local_img :"@/assets/zsb_local_download_qr.png";
        this.ios_url = data.data.ios_url;
        this.ios_img = data.data.ios_img ? data.data.ios_img : "@/assets/zsb_ios_download_qr.png";
        this.android_url = data.data.android_url;
        this.android_img = data.data.android_img ? data.data.android_img : "@/assets/zsb_android_download_qr.png";
      } catch (error) {
        console.error('获取用户信息失败：', error);
      }
    }
  },
  initMap() {
    // 创建地图实例
    // this.map = new BMap.Map('map');
    //
    // // 创建点坐标
    // this.point = new BMap.Point(116.404, 39.915);
    //
    // // 初始化地图，设置中心点坐标和地图级别
    // this.map.centerAndZoom(this.point, 15);
    //
    // // 添加地图类型控件
    // this.map.addControl(new BMap.MapTypeControl());
    //
    // // 设置地图显示的类型为普通道路图
    // this.map.setMapType(BMAP_NORMAL_MAP);
    //
    // // 开启鼠标滚轮缩放
    // this.map.enableScrollWheelZoom(true);
    // }
  },
  mounted() {
    // this.initMap();
    this.getAppDownloadInfo();
  }
}
</script>


<style lang="scss" scoped>
.wxtip {
  background: rgba(0, 0, 0, 0.8);
  text-align: center;
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 100;
  //display: none;
  img {
    width: 100%;
  }
}

.wxtip-txt {
  margin-top: 107px;
  color: #fff;
  font-size: 28px;
  line-height:2.8;
}
.ksl_section_one_title_phone {
  width: 876px;
  height: 492px;
}

a {
  text-decoration: none;
  color: rgba(51, 51, 51, .4);
}

.ksl_footer {
  width: 100%;
  box-sizing: border-box;
  background: #FFDF0F;
  padding: 80px 434px 20px 432px;
  color: #333333;

  .ksl_footer_content {
    display: flex;
    gap: 194px;

    .ksl_footer_left {
      font-size: 16px;
      text-align: left !important;
      justify-content: flex-start;

      .ksl_footer_left_title {
        font-size: 40px;
        margin-bottom: 30px;
      }

      .ksl_footer_left_info {
        display: flex;
        flex-direction: column;
        gap: 15px;
      }
    }

    .ksl_footer_right {
      width: 452px !important;
      height: 260px !important;
    }
  }

  .ksl_footer_agreement {
    cursor: pointer;
  }

  .ksl_footer_icp {
    margin-top: 20px;
    font-size: 14px;
    display: flex;
    color: rgba(51, 51, 51, .4);
    justify-content: center;
    gap: 6px;
  }

  .ksl_footer_copyright {
    margin-top: 10px;
    font-size: 14px;
    color: rgba(51, 51, 51, .4);
  }

}

.ksl_section_five {
  position: relative;
  box-sizing: border-box;
  height: 1080px;
  background: url("../../assets/zsb_1_5.png") no-repeat;

  background-size: cover;
  background-position: center 0;
  /* 设置多浏览器支持 */
  -webkit-background-size: cover; /*设置背景图片的尺寸*/
  -o-background-size: cover;
  -moz-background-size: cover;

}

.ksl_section_four {
  position: relative;
  box-sizing: border-box;
  height: 1971px;
  background: url("../../assets/zsb_1_3.png") no-repeat;

  background-size: cover;
  background-position: center 0;
  /* 设置多浏览器支持 */
  -webkit-background-size: cover; /*设置背景图片的尺寸*/
  -o-background-size: cover;
  -moz-background-size: cover;

}

.ksl_section_two {
  position: relative;
  box-sizing: border-box;
  height: 1080px;
  background: url("../../assets/zsb_1_1.png") no-repeat;
  background-size: cover;
  background-position: center 0;
  /* 设置多浏览器支持 */
  -webkit-background-size: cover; /*设置背景图片的尺寸*/
  -o-background-size: cover;
  -moz-background-size: cover;
  /* 设置背景颜色，背景图加载过程中会显示背景色 */
  //.ksl_section_two_title_bg{
  //  position: absolute;
  //  left: 177px;
  //
  //}
  //.ksl_section_two_title_desc{
  //  font-weight: bold;
  //  font-size: 46px;
  //  color: #333333;
  //  position: absolute;
  //  left: 322px;
  //  top: 131px;
  //}
  //.ksl_section_two_bg{
  //  width: 100%;
  //  text-align: center;
  //  background: url("../../assets/two_bg.png") no-repeat;
  //  background-position: center center;
  //  background-size: 100% 100%;
  //}
}

.ksl_section_tree {
  position: relative;
  box-sizing: border-box;
  height: 1080px;
  background: url("../../assets/zsb_1_2.png") no-repeat;
  background-size: cover;
  background-position: center 0;
  /* 设置多浏览器支持 */
  -webkit-background-size: cover; /*设置背景图片的尺寸*/
  -o-background-size: cover;
  -moz-background-size: cover;
  //.ksl_section_two_title_bg{
  //  position: absolute;
  //  left: 177px;
  //
  //}
  //.ksl_section_two_title_desc{
  //  font-weight: bold;
  //  font-size: 46px;
  //  color: #333333;
  //  position: absolute;
  //  left: 322px;
  //  top: 131px;
  //}
  //.ksl_section_two_bg{
  //  width: 100%;
  //  text-align: center;
  //  background: url("../../assets/two_bg.png") no-repeat;
  //  background-position: center center;
  //  background-size: 100% 100%;
  //}
}


.is-right {
  display: flex;
  justify-content: flex-end;
  margin-right: 60px;
}

.is-left {
  display: flex;
  justify-content: center;
  margin-left: 60px;
}

.el-main {
  width: 100%;
  height: 100vh;
  text-align: center;
  background-color: rgba(251, 252, 252, 1);
  padding: 0; //这里要再添加 padding，页面才能生效
}

.ksl_page {
  box-sizing: border-box;
  width: 100%;

  .ksl_header_bar {
    box-sizing: border-box;
    background-color: #fff;
  }

  .ksl_section_one {
    text-align: center;
    background: url("../../assets/bg.png") no-repeat;
    background-position: center center;
    background-size: 100% 100%;
    width: 100%;
    box-sizing: border-box;
    padding-top: 68px;
    padding-bottom: 60px;

    .ksl_section_one_title_img {
      width: 1120px;
      height: 170px;
    }

    .ksl_section_one_title_desc {
      font-weight: 400;
      font-size: 40px;
      color: #5A2929;
      margin-top: -20px;
    }

    .ksl_section_one_download {
      padding-top: 70px;
      padding-bottom: 35px;
      box-sizing: border-box;

      .ksl_section_one_download_item {
        width: 342px;
        height: 100px;
        font-size: 32px;
        border-radius: 16px 16px 16px 16px;
        border: 3px solid #FCF6D7;
        opacity: 0.69;
        display: flex;
        justify-content: center;
        align-items: center;
        color: #5A2929;
        cursor: pointer;
      }

      .ksl_section_one_download_item:hover {
        background: #F9F4D0;
      }
    }
  }
}


</style>



// WEBPACK FOOTER //
// src/view/zsb/index.vue